import { fontSize } from "config/styles/fonts";

const styles = {
  contentWrap: {
    height: {
      xs: "calc(100dvh - 40px)",
      md: "100%",
    },
  },
  header: {
    p: {
      xs: "20px 16px 0",
      md: "20px 36px 0",
    },
  },
  listWrap: {
    "&.MuiList-root": {
      pt: 0,
      pb: 0,
      mt: 0,
    },
    "& .MuiButtonBase-root": {
      height: "52px",
      borderBottom: "1px solid",
      borderBottomColor: "background.modalBg",
      p: {
        xs: "8px 16px",
        md: "8px 36px",
      },
    },
  },
  optionsWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    height: {
      xs: "50%",
      xxl: "60%",
    },
    overflowY: "auto",
  },
  option: (isChecked: boolean) => ({
    color: isChecked ? "green.main" : "inherit",
    "&.MuiButtonBase-root.MuiListItemButton-root.Mui-selected": {
      backgroundColor: isChecked ? "green.itemHover" : "inherit",
    },
  }),
  icon: (isVisible: boolean) => ({
    visibility: isVisible ? "visible" : "hidden",
    "&.MuiListItemIcon-root": {
      justifyContent: "flex-end",
      color: "green.main",
    },
  }),
  footer: {
    position: "absolute",
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    width: "100%",
    p: {
      xs: "0 16px 20px",
      md: "0 36px 20px",
    },
  },
  btn: {
    height: "56px",
    fontSize: fontSize.l,
    textTransform: "capitalize",
    borderRadius: "50px",
  },
};

export default styles;
